import { render, staticRenderFns } from "./EcGrid.vue?vue&type=template&id=2f996a98&scoped=true&"
import script from "./EcGrid.vue?vue&type=script&lang=ts&"
export * from "./EcGrid.vue?vue&type=script&lang=ts&"
import style0 from "./EcGrid.vue?vue&type=style&index=0&id=2f996a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f996a98",
  null
  
)

export default component.exports